const state = {
  isLoading: false,
};

const getters = {
  isLoading: (state) => state.isLoading,
};

const mutations = {
  /**
   * ローディング表示を中止する
   * @param {*} state
   */
  close(state) {
    state.isLoading = false;
  },
  /**
   * ローディング表示する
   * @param {*} state
   */
  show(state) {
    state.isLoading = true;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
